import { render, staticRenderFns } from "./GroupsByRule.vue?vue&type=template&id=2e1c1357&scoped=true&"
import script from "./GroupsByRule.vue?vue&type=script&lang=js&"
export * from "./GroupsByRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c1357",
  null
  
)

export default component.exports